import axios from "axios";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { Toaster } from "react-hot-toast";
import Header from "../Common/Header/Header";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import { notify } from "../Utility/Notify";
import "./Purchase.css";
// import useInventory from "../Hooks/useInventory";
import { AiOutlineClose } from "react-icons/ai";
import SelectSupplier from "../Common/CustomSelect/SelectSupplier";
import WareHouseDWPurchase from "../Common/CustomSelect/WareHouseDWPurchase";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  resetRtv,
  selectCalculation,
  selectNote,
  selectProducts,
  selectSupplier,
  selectUser,
  selectWareHouse,
} from "../../features/rtvSlice";
import { useAddRtvMutation, useRtvsCountQuery } from "../../services/rtvApi";
import { useSupplierPurchaseQuery } from "../../services/supplierApi";
import { useWarehouseQuery } from "../../services/warehouseApi";
import CsvPurchaseProduct from "../Common/CsvImporter/CsvPurchaseProduct";
import SelectPriceGrn from "../Common/CustomSelect/ScelectPriceGrn";
import LoadingModal from "../Common/Modal/LoadingModal";
import PackageModal from "../Common/Modal/PackageModal";
import useRtv from "../Hooks/useRtv";
import { apiUniqueErrHandle } from "../Utility/Utility";
import SupplierProductDetail from "./parts/SupplierProductDetail";
// import PosCart from "../Pages/POS/Parts/PosCart";
// import useProducts from "../Hooks/useProducts";

const CreateRtv = () => {
  let i = 1;
  let j = 1;
  let navigate = useNavigate();
  // const purchaseCart = JSON.parse(localStorage.getItem("rtvCart"));
  const [addRtv] = useAddRtvMutation();
  const [supplierId, setSupplierId] = useState("");

  const [supplier, setSupplier] = useState([]);
  const [csvData, setCsvData] = useState([]);
  // const [aamarId, setAamarId] = useState("");
  // const [isFull, setIsFull] = useState(false);

  const dispatch = useDispatch();
  const rtvData = useSelector((state) => state.rtvReducer);
  // const [calcTotal, setCalcTotal] = useState([]);
  const auth = signInUser();
  const [wh, setWh] = useState("");
  const [supplierProducts, setSupplierProducts] = useState([]);
  const [onShow, setOnShow] = useState(false);
  const handleClose = () => setOnShow(false);
  const [modalVisible, setModalVisible] = useState(false);
  const closeModal = () => setModalVisible(false);
  const { data, isSuccess, refetch } = useSupplierPurchaseQuery(supplierId, {
    skip: !supplierId,
  });

  const BASE_URL =
    process.env.REACT_APP_API_URL || "http://localhost:5001/api/";
  const [filteredProduct, setFilteredProduct] = useState([]);

  const { totalItems } = useRtv();

  const { totalItem, total } = totalItems(rtvData.products);
  const [whName, setWhName] = useState("Warehouse");

  const { data: warehouseData, refetch: whRefetch } = useWarehouseQuery(
    auth?.warehouse
  );
  const { data: countData } = useRtvsCountQuery(auth?.aamarId);
  useEffect(() => {
    if (auth?.warehouse) {
      whRefetch();
    }
  }, [auth?.warehouse, whRefetch]);

  useEffect(() => {
    if (warehouseData) {
      setWhName(warehouseData?.name);
      whRefetch();
    }
  }, [warehouseData, whRefetch]);

  useEffect(() => {
    setOnShow(false);
    if (data && supplierId) {
      setSupplierProducts(data?.products || []);
      dispatch(selectSupplier(data?._id));
      dispatch(selectProducts([]));
    } else if (!supplierId) {
      setSupplierProducts([]);
      dispatch(selectSupplier(""));
      dispatch(selectProducts([]));
    }
  }, [isSuccess, data, supplierId]);
  // console.log("warehouse", warehouseData);
  useEffect(() => {
    if (supplierId) {
      refetch();
    }
  }, [supplierId, refetch]);

  useEffect(() => {
    if (supplierProducts?.length > 0) {
      setFilteredProduct(supplierProducts);
    } else {
      setFilteredProduct([]);
    }
  }, [supplierProducts, rtvData]);

  useEffect(() => {
    dispatch(selectCalculation({ totalItem, total }));
  }, [totalItem, total]);

  console.log("Count DATA", countData);
  console.log("rtvLimited", auth?.package?.rtvLimited);

  // SUBMIT RTV
  const handleBillSubmit = async () => {
    if (!rtvData?.products || rtvData.products.length === 0) {
      notify("Please add at least one product to the RTV cart", "error");
      return;
    }
    if (countData >= auth?.package?.rtvLimited) {
      setModalVisible(true);
      return;
    } else {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Create New RTV?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, create it!",
      });

      if (result.isConfirmed) {
        // dispatch(selectProducts([]));
        const response = await addRtv(rtvData);

        if (response) {
          // console.log(response);
          if (response?.error) {
            apiUniqueErrHandle(response);
            notify("Please Select All Fields", "error");
          } else {
            notify(response?.data?.message, "success");
            dispatch(resetRtv());
            setSupplier({});
            return navigate("/rtv");
          }
        }
      } else {
        notify("Cancelled by User", "error");
      }
    }
  };

  // SELECT SUPPLIER
  const handleVendorChange = (selectedOption) => {
    if (selectedOption && selectedOption.value) {
      setSupplierId(selectedOption.value); // Update supplierId with the selected value
      //  setOnShow(true); // Trigger any additional action
    } else {
      setSupplierId(""); // Reset if no option is selected
    }
  };
  useEffect(() => {
    dispatch(selectWareHouse(auth?.warehouse));
    dispatch(selectUser(auth?.id));
  }, []);

  const handleOnchangeWareHouse = (e) => {
    setWh(e.option);
    dispatch(selectWareHouse(e.option));
  };

  // useEffect(() => {
  //   if (purchaseCart) {
  //     const newPurchaseCart = purchaseCart?.sort((a, b) => a.order - b.order);
  //     setPurchaseView(newPurchaseCart);
  //   }
  // }, [purchaseCart]);

  // useEffect(() => {
  //   setCalcTotal(total(purchaseCarts));
  //   // const [tot]
  // }, [purchaseCarts]);

  // POS Cart

  const emptyCart = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Refresh Cart! Start New RTV?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Reset it!",
    });

    if (result.isConfirmed) {
      dispatch(selectProducts([]));
    } else {
      // console.log("Refresh Operation Cancelled by POSER");
    }
  };

  // console.log(purchaseView)

  const localStorageAddFromCart = (itemOrId) => {
    const prodId =
      typeof itemOrId === "object"
        ? itemOrId?.id?._id || itemOrId?.id || itemOrId?._id
        : itemOrId;

    const selected =
      supplierProducts?.find(
        (p) => (p?.id?._id || p?.id || p?._id) === prodId
      ) || (typeof itemOrId === "object" ? itemOrId : null);

    if (!selected) {
      notify("Product not found in supplier products", "error");
      return;
    }

    const priceList = selected?.id?.priceList || selected?.priceList || [];
    const activePriceList = priceList?.filter((pr) => pr?.status === "active");
    const effectivePriceList =
      activePriceList && activePriceList.length > 0
        ? activePriceList
        : priceList;

    const latestPrice =
      effectivePriceList && effectivePriceList.length > 0
        ? effectivePriceList[0]
        : null;

    const actualId = selected?.id?._id || selected?.id || selected?._id;
    const priceId = latestPrice?._id || selected?.priceId || undefined;
    const tp =
      latestPrice?.tp !== undefined
        ? Number(latestPrice.tp)
        : Number(selected?.tp || 0);
    const mrp =
      latestPrice?.mrp !== undefined
        ? Number(latestPrice.mrp)
        : Number(selected?.mrp || 0);
    const unit =
      typeof selected?.unit === "object" && selected?.unit?.name
        ? selected.unit.name
        : selected?.unit || selected?.id?.unit || "pcs";
    const whTarget = auth?.warehouse || wh;

    const targetArticleCode =
      selected?.article_code || selected?.id?.article_code;

    const existingProducts = rtvData?.products || [];
    const exist = existingProducts.find(
      (p) => p.id === actualId || p.article_code === targetArticleCode
    );

    if (exist) {
      notify("Product already selected", "error");
      return;
    }

    notify("Product is selected", "success");
    const newItem = {
      id: actualId,
      article_code: targetArticleCode,
      priceId: priceId,
      tp: tp,
      mrp: mrp,
      newPrice: false,
      name: selected.name || selected.id?.name,
      tax: 0,
      qty: 1,
      unit: unit,
      discount: 0,
      warehouse: whTarget,
      aamarId: auth?.aamarId,
      order: existingProducts.length + 1,
    };

    dispatch(selectProducts([...existingProducts, newItem]));
  };


  // HANDLE CUSTOM QTY
  const handleCustomQty = (e, id) => {
    const customQty = e.target.value !== "" ? e.target.value : 0;

    const item = rtvData.products.find((p) => p.id === id);
    const remain = rtvData.products.filter((p) => p.id !== id);
    if (item) {
      // let restItem = cartItems.filter((item) => item.article_code !== id);
      if (customQty >= 0) {
        const newGrn = [
          ...remain,
          {
            ...item,
            qty: customQty,
          },
        ];
        dispatch(selectProducts(newGrn));
        // setIsFull(false);
      }
    }
  };

  const handleOnChangePrice = async (id, e) => {
    let price = await axios.get(`${BASE_URL}price/${e.option}`);
    // console.log(price);
    let selected = rtvData.products.find((item) => item.id === id);
    let rest = rtvData.products.filter((item) => item.id !== id);
    let newCart = [];
    if (price.data) {
      newCart = [
        ...rest,
        {
          ...selected,
          mrp: price.data?.mrp,
          tp: price.data?.tp,
          priceId: price.data?._id,
        },
      ];
    }

    dispatch(selectProducts(newCart));
    dispatch(selectProducts(newCart));
    // localStorage.setItem("pos_cart", JSON.stringify(newCart));
    // console.log(e.option);
    // updateCart();
  };

  const handleNewPrice = (id) => {
    let pro = rtvData.products;
    const select = pro.find((p) => p.id === id);
    const rest = pro.filter((p) => p.id !== id);
    // console.log(pro, state);
    let newProduct = [...rest, { ...select, newPrice: !select.newPrice }];
    // console.log(rest, select, id);
    dispatch(selectProducts(newProduct));

    // return { ...state, products:  };
  };

  const removeFromGrn = (id) => {
    const remain = rtvData.products?.filter((p) => p.id !== id);
    dispatch(selectProducts(remain));
    notify("Product Removed", "error");
    // setIsFull(false);
  };

  // const handleSearch = (q) => {
  //   // console.log(q);
  //   if (q.length > 0) {
  //     const re = new RegExp(q, "i");
  //     const filtered = supplierProducts.filter((entry) =>
  //       Object.values(entry).some(
  //         (val) => typeof val === "string" && val.match(re)
  //       )
  //     );

  //     setFilteredProduct(filtered);
  //     // console.log("Original:", supplierProducts);
  //     // console.log("filter:", filtered);
  //   } else {
  //     setFilteredProduct(supplierProducts);
  //   }
  // };
  const handleSearch = (q) => {
    if (q && q.trim().length > 0) {
      const qLower = q.trim().toLowerCase();
      const filtered = supplierProducts?.filter((entry) => {
        const name = (entry?.name || entry?.id?.name || "").toString().toLowerCase();
        const article = (entry?.article_code || entry?.id?.article_code || "").toString().toLowerCase();
        const ean = (entry?.ean || entry?.id?.ean || "").toString().toLowerCase();
        return (
          name.includes(qLower) ||
          article.includes(qLower) ||
          ean.includes(qLower)
        );
      });
      setFilteredProduct(filtered);
    } else {
      setFilteredProduct(supplierProducts || []);
    }
  };
  const handleImportButton = async () => {
    if (!csvData || csvData.length === 0) {
      notify("There is no products to import", "error");
      return;
    }

    setOnShow(true);
    try {
      const importedProducts = [];
      const notFoundCodes = [];

      for (let i = 0; i < csvData.length; i++) {
        const pro = csvData[i];
        const code = pro?.article_code ? String(pro.article_code).trim() : "";
        if (!code) continue;

        try {
          const details = await axios(
            `${BASE_URL}product/pro-details/${encodeURIComponent(code)}`
          );
          const data = details?.data;

          if (details?.status === 200 && data && data?._id) {
            const activePrice =
              data?.priceList?.find((p) => p?.status === "active") ||
              data?.priceList?.[0] ||
              {};
            const tpVal =
              activePrice?.tp !== undefined && Number(activePrice.tp) >= 0
                ? Number(activePrice.tp)
                : 0;
            const mrpVal =
              activePrice?.mrp !== undefined && Number(activePrice.mrp) >= 0
                ? Number(activePrice.mrp)
                : 0;

            importedProducts.push({
              id: data._id,
              article_code: data.article_code || code,
              priceId: activePrice?._id || data._id,
              tp: tpVal,
              mrp: mrpVal,
              name: data.name,
              qty: Number(pro?.qty) > 0 ? Number(pro.qty) : 1,
              tax: 0,
              discount: 0,
              warehouse: auth?.warehouse,
              order: pro?.order
                ? Number(pro.order)
                : (rtvData?.products?.length || 0) + importedProducts.length + 1,
            });
          } else {
            notFoundCodes.push(code);
          }
        } catch (itemErr) {
          console.error(`Error importing product ${code}:`, itemErr);
          notFoundCodes.push(code);
        }
      }

      if (importedProducts.length > 0) {
        const existingProducts = rtvData?.products || [];
        const existingMap = new Map();
        existingProducts.forEach((p) => {
          existingMap.set(String(p.article_code || p.id), { ...p });
        });

        for (const item of importedProducts) {
          const key = String(item.article_code || item.id);
          if (existingMap.has(key)) {
            const existing = existingMap.get(key);
            existingMap.set(key, {
              ...existing,
              qty: Number(existing.qty || 0) + Number(item.qty || 1),
            });
          } else {
            existingMap.set(key, {
              ...item,
              order: existingMap.size + 1,
            });
          }
        }

        const mergedProducts = Array.from(existingMap.values());
        dispatch(selectProducts(mergedProducts));
        notify(`${importedProducts.length} product(s) imported successfully!`, "success");
      }

      if (notFoundCodes.length > 0) {
        if (notFoundCodes.length <= 4) {
          notify(`Product(s) not found in store: ${notFoundCodes.join(", ")}`, "error");
        } else {
          notify(
            `${notFoundCodes.length} product(s) not found in store (e.g. ${notFoundCodes.slice(0, 3).join(", ")}...)`,
            "error"
          );
        }
      }
    } catch (err) {
      console.error("Import failed:", err);
      notify(err?.message || "Import failed", "error");
    } finally {
      setOnShow(false);
    }
  };
  console.log("filteredProduct", filteredProduct);

  return (
    <div>
      <div className="container-fluid ">
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10 mt-2">
            <Header title="Create New RTV"></Header>

            <Form className="pt-3" action="javascript:void(0)">
              <div className="row">
                <div className="col-12 col-md-6">
                  <Form.Group controlId="warehouse">
                    <Form.Label>Warehouse</Form.Label>

                    {auth?.type !== "admin" ? (
                      <>
                        <br />
                        {whName}
                      </>
                    ) : (
                      <WareHouseDWPurchase
                        handleOnChange={handleOnchangeWareHouse}
                        wh={wh}
                      />
                    )}
                  </Form.Group>
                </div>
                <div className="col-12 col-md-6">
                  <Form.Group>
                    <Form.Label>Supplier</Form.Label>
                    <SelectSupplier
                      selected={{ value: supplierId }} // Pass current selected supplier
                      handleOnchange={handleVendorChange}
                    />
                  </Form.Group>
                </div>
                <div className="col-12 col-md-8 mb-3 ">
                  <CsvPurchaseProduct
                    title="Supplier Product"
                    setCsvData={setCsvData}
                    handleImportButton={handleImportButton}
                  />
                </div>

                <div className="col-12">
                  <div className="row">
                    <div className="col-12 col-md-5">
                      <div className="card">
                        <div className="card-header">
                          Supplier Products List
                          <div>
                            <input
                              className="form-control "
                              type="text"
                              placeholder="Search Product"
                              onChange={(e) => handleSearch(e.target.value)}
                            />
                          </div>
                        </div>
                        <div
                          style={{
                            overflowY: "scroll",
                            display: "block",
                            height: "200px",
                          }}
                        >
                          {filteredProduct?.length > 0 ? (
                            <Table className="mt-3 table-responsive-sm">
                              <thead className="">
                                <tr>
                                  <th className="ps-2">Code</th>
                                  <th className="ps-4">Name</th>
                                  <th>Stock</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {filteredProduct?.map((item, index) => (
                                  <SupplierProductDetail
                                    cartItem={item}
                                    index={index}
                                    localStorageAddFromCart={
                                      localStorageAddFromCart
                                    }
                                  ></SupplierProductDetail>
                                  // <SupplierProduct
                                  //   productList={filteredProduct}
                                  //   localStorageAddFromCart={handleSelectItem}
                                  // />
                                  // <tr key={item.article_code}>
                                  //   <td>{item.article_code}</td>
                                  //   <td>{item.name}</td>
                                  //   <td>0</td>
                                  //   <td>
                                  //     <BsArchive
                                  //       onClick={() =>
                                  //         handleSelectItem(item.id._id)
                                  //       }
                                  //     />
                                  //   </td>
                                  // </tr>
                                ))}
                              </tbody>
                            </Table>
                          ) : (
                            <Table className="mt-3 table-responsive-sm">
                              <thead>
                                <tr>
                                  <th>Code</th>
                                  <th>Name</th>
                                  <th>Stock</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <th colSpan={8} className="text-center">
                                    Please Select a Supplier
                                  </th>
                                </tr>
                              </tbody>
                            </Table>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-7 mt-2 mt-md-0">
                      <div className=" card px-1 ">
                        <Table className="mt-3  ">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Code</th>
                              <th>Name</th>
                              <th>Quantity</th>
                              <th>TP</th>
                              <th>MRP</th>
                              <th>Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            {rtvData?.products?.length > 0 ? (
                              rtvData?.products
                                .slice()
                                .sort((a, b) => b.order - a.order)
                                .map((item, index) => (
                                  <tr key={item?.id}>
                                    <th>{index + 1}</th>
                                    <td>{item?.article_code}</td>
                                    <td className="col-2">{item?.name}</td>
                                    <td className="col-2">
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control quantity"
                                          onChange={(e) =>
                                            handleCustomQty(e, item?.id)
                                          }
                                          value={item?.qty}
                                        />
                                      </div>
                                    </td>
                                    <td className="col-2">
                                      <input
                                        type="text"
                                        disabled={
                                          !item?.newPrice ? "disabled" : ""
                                        }
                                        className="form-control quantity"
                                        value={parseFloat(item?.tp).toFixed(2)}
                                      />
                                    </td>
                                    <td className="col-2">
                                      {item?.newPrice ? (
                                        <input
                                          type="text"
                                          className="form-control quantity"
                                          value={item?.mrp}
                                        />
                                      ) : (
                                        <SelectPriceGrn
                                          sc={item?.id}
                                          setVal={item?.mrp}
                                          handleOnChangeCategory={
                                            handleOnChangePrice
                                          }
                                        />
                                      )}
                                    </td>
                                    <td>
                                      {(
                                        parseFloat(item?.qty) *
                                        (parseFloat(item?.tp) +
                                          parseFloat(item?.tp) *
                                            (item?.tax
                                              ? parseFloat(item?.tax) / 100
                                              : 0))
                                      ).toFixed(2)}
                                    </td>
                                    <td>
                                      <AiOutlineClose
                                        onClick={() => removeFromGrn(item.id)}
                                      />
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <th colSpan={8} className="text-center">
                                  Please Select a Product to return
                                </th>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <Form.Group controlId="formBasicEmail">
                    <Form.Label>Note</Form.Label>
                    <textarea
                      onChange={(e) => dispatch(selectNote(e.target.value))}
                      className="form-control"
                      placeholder="Note"
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-12 col-md-auto">
                  <Button
                    variant="dark"
                    className="float-end my-2 mt-2"
                    type="button"
                    onClick={handleBillSubmit}
                  >
                    Submit
                  </Button>
                  <Button
                    variant="dark"
                    className="float-end my-2 mx-2 mt-2"
                    type="button"
                    onClick={emptyCart}
                  >
                    Reset Cart
                  </Button>
                </div>
              </div>

              <Table className="bordered striped mt-3">
                {/* <thead>
      <tr>
        <th>Items: {totalItem}</th>
        <th>Total: {total}</th>
        <th>Round Total: {Math.round(total)}</th>
      </tr>
    </thead> */}
              </Table>
            </Form>
          </div>
        </div>
        <LoadingModal
          onShow={onShow}
          title="Please Wait.."
          handleClose={handleClose}
        />
        <Toaster position="bottom-right" />
        {/* Package Info Modal */}
        <PackageModal show={modalVisible} handleClose={closeModal} />{" "}
      </div>
    </div>
  );
};

export default CreateRtv;
